'use client';

import { Link } from '@/i18n/navigation';
import type React from 'react';

type LocalizedHref = React.ComponentProps<typeof Link>['href'];

interface ButtonProps {
    innerText?: string;
    btnBgColor?: string;
    borderWidth?: string;
    borderColor?: string;
    customClassName?: string;
    children?: React.ReactNode;
    href?: LocalizedHref;
    externalUrl?: string;
    loading?: boolean;
    type?: 'button' | 'submit' | 'reset';
    disabled?: boolean;
    onClick?: React.MouseEventHandler<HTMLAnchorElement | HTMLButtonElement>;
}

export default function AppButton({
    innerText = '',
    btnBgColor,
    borderWidth,
    borderColor,
    customClassName,
    children,
    href,
    loading,
    externalUrl,
    type,
    disabled,
    onClick,
}: ButtonProps) {
    const _bg = btnBgColor ? `bg-[${btnBgColor}] ` : '';
    let _border = '';
    const _className = customClassName ? `${customClassName} ` : '';

    if (borderWidth) _border = `border border-${borderWidth} `;
    _border += `border-${borderColor ?? 'white'} `;

    if (externalUrl) {
        return (
            <a
                href={externalUrl}
                target="_blank"
                rel="noopener noreferrer"
                className={`${_bg + _border + _className}text-white text-center w-fit px-7 py-4 font-bold rounded-[12px] cursor-pointer hover:bg-[#B10DCE] hover:border-[#B10DCE] transition duration-300`}
                onClick={onClick as React.MouseEventHandler<HTMLAnchorElement>}
            >
                {innerText}
                {children}
            </a>
        );
    }

    return href ? (
        <Link
            href={href}
            className={`${_bg + _border + _className}text-white text-center w-fit px-7 py-4 font-bold rounded-[12px] cursor-pointer hover:bg-[#B10DCE] hover:border-[#B10DCE] transition duration-300`}
            onClick={onClick as React.MouseEventHandler<HTMLAnchorElement>}
        >
            {loading ? (
                <div className="spinner" />
            ) : (
                <>
                    {innerText}
                    {children}
                </>
            )}
        </Link>
    ) : (
        <button
            type={type}
            disabled={disabled}
            className={`
        ${_bg}${_border}${_className}
        text-white text-center w-fit px-7 py-4 font-bold rounded-[12px]
        ${disabled ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer hover:bg-[#B10DCE] hover:border-[#B10DCE]'}
        transition duration-300
      `}
            onClick={onClick as React.MouseEventHandler<HTMLButtonElement>}
        >
            {loading ? (
                <div className="spinner" />
            ) : (
                <>
                    {innerText}
                    {children}
                </>
            )}
        </button>
    );
}
